"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettify = void 0;
const types_1 = require("../../types");
const style_1 = require("../../style");
const code_1 = require("../../code");
const json_1 = require("../../json");
function prettify(context) {
    const { dataPath, error: { params: { i, j } } } = types_1.getTypedContext(context);
    const [a, b] = [i, j].sort();
    const valueA = json_1.getValueByPath(context, dataPath.dotOnly + `.${a}`);
    const [prePath, pathExpr, postPath] = style_1.pathDescription(context, 'array');
    const title = style_1.style.title(`The ${prePath}`, context) +
        pathExpr +
        style_1.style.title(`${postPath} should have unique items, but element `, context) +
        style_1.style.number(`${a}`, context) +
        style_1.style.title(" and ", context) +
        style_1.style.number(`${b}`, context) +
        style_1.style.title(" are identical: ", context) +
        style_1.formatValue(valueA, context);
    const codeFrame = code_1.printCode('Remove element ' +
        style_1.style.number(`${a}`, context) +
        ' or ' +
        style_1.style.number(`${b}`, context), context.parsedJson, { dataPath: dataPath.dotOnly, markIdentifier: false });
    return { title, codeFrame };
}
exports.prettify = prettify;
